// extracted by mini-css-extract-plugin
export default {"container":"ImageAlbum_container__aqJGj","text":"ImageAlbum_text__qYNqa","img":"ImageAlbum_img__MyLgO"};